// extracted by mini-css-extract-plugin
export var headerRow = "header-module--headerRow--o61t3";
export var mr2 = "header-module--mr2--LGMxd";
export var partenaire = "header-module--partenaire--ytoaK";
export var perge = "header-module--perge--9oHET";
export var name = "header-module--name--Xos6x";
export var buttonGroup = "header-module--buttonGroup--N8zRQ";